import React, { useCallback } from 'react';

import { QBox, QTooltip } from '@captivateiq/quotient';

type SourceCitationChipProps = {
  index: number;
  source: string;
  label?: string;
  dataContext?: string;
};

export const SourceCitationChip = ({ index, source, label, dataContext }: SourceCitationChipProps) => {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (source) {
        window.open(source, '_blank', 'noopener,noreferrer');
      }
    },
    [source],
  );

  return (
    <QTooltip placement="top" title={dataContext || label || source}>
      <QBox
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '14px',
          height: '14px',
          px: '3px',
          ml: '2px',
          fontSize: '9px',
          fontWeight: 600,
          lineHeight: 1,
          color: 'white',
          backgroundColor: 'grey.500',
          borderRadius: '7px',
          cursor: source ? 'pointer' : 'default',
          verticalAlign: 'text-top',
          textDecoration: 'none',
          '&:hover': {
            backgroundColor: 'primary.main',
          },
        }}
        onClick={handleClick}
      >
        {index}
      </QBox>
    </QTooltip>
  );
};
